import { useForm } from "react-hook-form";
import AddResource from "../../components/header/AddResource";
import { useNotification } from "../../components/notification/NotificationContainer";
import InputField from "../../components/form/InputField";
import ColorPicker from "../../components/form/ColorPicker";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useLayoutEffect } from "react";
import ResourseButtons from "../../components/form/buttons/ResourseButtons";
import { zodResolver } from "@hookform/resolvers/zod";
import { addRoleSchema } from "../../schemas";
import {
  addRole,
  editRole,
  getRole,
  setSelectedRole,
} from "../../features/rolesSlice";
import { closeModal } from "../../features/modalSLice";
import TextAreaField from "../../components/form/TextAreaField";

const AddRole = ({ edit, id }) => {
  const dispatch = useDispatch();
  const addNotification = useNotification();
  const user = useSelector((state) => state.user.userInfo);
  const role = useSelector((state) => state.roles.selected);
  const editLoad = useSelector((state) => state.roles.load.editRole);
  const addLoad = useSelector((state) => state.roles.load.addRole);

  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: { color: "" },
    resolver: zodResolver(addRoleSchema),
  });

  const onSubmit = async (data, e) => {
    e.preventDefault();
    try {
      if (edit) {
        const res = await dispatch(editRole({ id, reqData: data }));
        if (editRole.fulfilled.match(res)) {
          dispatch(closeModal());
          dispatch(setSelectedRole(res.payload));
          addNotification("Role Updated Successfully!", "success");
        } else {
          addNotification(res.payload.message, "error");
        }
      } else {
        const res = await dispatch(addRole(data));
        if (addRole.fulfilled.match(res)) {
          dispatch(closeModal());
          addNotification("Role Added Successfully!", "success");
        } else {
          addNotification(res.payload.message, "error");
        }
      }
    } catch (error) {
      addNotification(error.message, "warning");
    }
  };

  useEffect(() => {
    if (user.id) {
      reset({ province_id: user.province_id });
    }
    if (edit && role.id) {
      reset({
        name: role.name,
        color: role.color,
        province_id: role.province_id,
        description: role.description,
      });
    } else if (edit && !role.id) {
      dispatch(getRole(id));
    }
  }, []);

  useLayoutEffect(() => {
    reset({
      name: role.name,
      color: role.color,
      province_id: role.province_id,
      description: role.description,
    });
  }, [role]);

  return (
    <div className=" min-w-[85vw] sm:min-w-[26rem] lg:min-w-96">
      <AddResource title={edit ? "Edit Role" : "Add Role"} />{" "}
      <form
        autoCorrect="off"
        autoComplete="off"
        aut
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="flex flex-col justify-center items-center gap-2 w-full">
          <InputField
            register={register}
            name="name"
            label="Name"
            autoComplete="off"
            type="text"
            errors={errors.name}
          />
          <TextAreaField
            register={register}
            name="description"
            label="Description"
            errors={errors.description}
          />
          <ColorPicker
            type="color"
            register={register}
            label="Color"
            name="color"
            errors={errors.color}
          />
        </div>
        <ResourseButtons loading={editLoad || addLoad} />
      </form>
    </div>
  );
};

export default AddRole;
